import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TabViewModel from "./../factories/tab-controller";
import TabPage from "./../factories/tab-page";
import SearchPaging from "./../factories/search-paging";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../bindings/foreach-selection";
import "./../bindings/slide-visible";
import "./../bindings/bao-tabs";
import "./../bindings/log";
function ServiceLevelAgreementViewModel(tabPage) {
    var self = this;
    self.ServiceLevelAgreementId = ko.observable();
    SearchPaging.call(this, tabPage);
    self.Bao = Bao;
    self.Initialized = ko.observable(false);
    self.TabViewModel = new TabViewModel();
    self.SelectedServiceLevelAgreementType = ko.observable();
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.ServiceLevelAgreement())) {
            isComplete = false;
        }
        if (self.ServiceLevelAgreementTypeId() == null) {
            isComplete = false;
        }
        $.each(self.TabViewModel.Tabs(), function (index, tab) {
            if (tab.PreLoad()) {
                if (!tab.ViewModel().CompleteCheck()) {
                    self.TabViewModel.SelectTab(tab);
                    isComplete = false;
                    return false;
                }
            }
        });
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.PerformRefresh = function () {
        tabPage.IsLoading(true);
        return Bao.post(self.RefreshUrl, JSON.stringify({
            id: self.ServiceLevelAgreementId()
        }), function (value) {
            tabPage.DirtyFlag.pause();
            tabPage.ObjectId(value.ServiceLevelAgreementId);
            delete value.ServiceLevelAgreementTabCollection;
            ko.map.fromJS(value, self);
            self.TabViewModel.RefreshTabs().then(function () {
                tabPage.IsLoading(false);
                tabPage.DirtyFlag.reset();
            });
        });
    };
    self.SaveTime = ko.observable();
    self.Save = function () {
        tabPage.IsLoading(true);
        return Bao.post(self.SaveUrl, JSON.stringify({
            model: self.MinimizeEntity()
        }), function (value) {
            self.SaveTime(value.Result);
            self.TabViewModel.SaveTabs(value.Result).then(function () {
                tabPage.DirtyFlag(false);
                self.PerformRefresh();
            });
        });
    };
    self.ServiceLevelAgreementTabCollection = ko.observableArray([]);
    self.ServiceLevelAgreementTabCollection.subscribe(function (newValue) {
        self.TabViewModel.Tabs([]);
        $.each(ko.map.toJS(newValue), function (index, item) {
            if (item.PreLoad == null) {
                item.PreLoad = false;
            }
            var newTab = new TabPage(null, item.Caption);
            newTab.AutoSelect = false;
            newTab.Url(item.WebUrl);
            newTab.IsClosable(false);
            newTab.PreLoad(item.PreLoad);
            newTab.TabLoaded = function () { };
            self.TabViewModel.AddTab(newTab);
        });
        if (self.TabViewModel.Tabs().length > 0) {
            self.TabViewModel.SelectTab(self.TabViewModel.Tabs()[0]);
        }
    });
    self.ServiceLevelAgreementTypeId = ko.observable();
    self.ServiceLevelAgreementTypeId.subscribe(function (newValue) {
        if (self.Initialized() == true) {
            Bao.post("ServiceLevelAgreement/GetTabsByServiceLevelAgreementTypeId", JSON.stringify({
                serviceLevelAgreementTypeId: newValue
            }), function (result) {
                self.ServiceLevelAgreementTabCollection(result);
            });
        }
    });
    self.loaded = function () {
        self.InitPaging();
        self.Initialized(true);
        tabPage.IsLoading(false);
    };
}
Bao.inherit(ServiceLevelAgreementViewModel, SearchPaging);
ServiceLevelAgreementViewModel.prototype.PrimaryKey = "ServiceLevelAgreementId";
ServiceLevelAgreementViewModel.prototype.RefreshUrl = "ServiceLevelAgreement/Get";
ServiceLevelAgreementViewModel.prototype.SaveUrl = "ServiceLevelAgreement/Save";
ServiceLevelAgreementViewModel.prototype.DeleteUrl = "ServiceLevelAgreement/Delete";
ServiceLevelAgreementViewModel.prototype.IsInUseUrl = "ServiceLevelAgreement/IsInUse";
ServiceLevelAgreementViewModel.prototype.PermissionForward = "ServiceLevelAgreementMoveForwardSearch";
ServiceLevelAgreementViewModel.prototype.PermissionBackward = "ServiceLevelAgreementMoveBackwardSearch";
ServiceLevelAgreementViewModel.prototype.PermissionSave = "ServiceLevelAgreementSave";
ServiceLevelAgreementViewModel.prototype.PermissionRefresh = "ServiceLevelAgreementRefresh";
ServiceLevelAgreementViewModel.prototype.PermissionDelete = "ServiceLevelAgreementDelete";
export default ServiceLevelAgreementViewModel;